import {Loader,WrapperDiv } from './Elements';

const SiteLoader = (props) => (
    <WrapperDiv>
        <Loader/>
    </WrapperDiv>
)
export default SiteLoader;